import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8i6qzemm69: FaireBrandEntity = {
  token: "b_8i6qzemm69",
  type: "brand",
  name: "Roots To Remedies",
  avatarUrl:
    "https://cdn.faire.com/fastly/8d04c3a0cbb8fd130fe58dba2bcc31bf8abc9f3c084f9240837579e58b65847a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/1350082dbab9fac30c5afbccb512690cb699a98025d0df62d40263dd06952668/1554998787.png",
  logoUrl:
    "https://cdn.faire.com/fastly/8d04c3a0cbb8fd130fe58dba2bcc31bf8abc9f3c084f9240837579e58b65847a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/1350082dbab9fac30c5afbccb512690cb699a98025d0df62d40263dd06952668/1554998787.png",
  location: "Morristown, TN, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 45,
  isTopShop: true,
  isInsider: true,
  description:
    "My name is Alexandra Duran. I have spent many years researching natural remedies and then later dove into herbalism and have found such a passion working with herbs. God has given us a beautiful planet that supplies us with incredible healing trees and plants. I am honored to help turn these plants and trees into healing products for you and your families. My heart is to help you take charge of your health and empower you to learn how to care for it by getting back to your roots.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:57.596Z",
    importedBy: "entity-db-cli",
  },
};
